"use strict";

exports.__esModule = true;
exports.ManualMaintenanceUserAction = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactIntl = require("react-intl");
var _ManualMaintenanceActionElement = require("./ManualMaintenanceActionElement");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var ManualMaintenanceUserAction = exports.ManualMaintenanceUserAction = {
  name: "Manual Maintenance",
  icon: "TicketsIcon",
  label: /*#__PURE__*/_react["default"].createElement(_reactIntl.FormattedMessage, {
    id: "ManualMaintenanceUserActionDefination.label",
    defaultMessage: "Manual Maintenance"
  }),
  description: /*#__PURE__*/_react["default"].createElement(_reactIntl.FormattedMessage, {
    id: "ManualMaintenanceUserActionDefination.description",
    defaultMessage: "Add Manual Maintenance"
  }),
  requiresContexts: ["device"],
  requiresProps: [],
  components: {
    Element: _ManualMaintenanceActionElement.ManualMaintenanceActionElement
  }
};